"use client"

import { Link, type LinkProps } from "react-router-dom"
import { ComponentPropsWithoutRef, forwardRef, type ReactNode } from "react"

type AnchorProps = Omit<ComponentPropsWithoutRef<"a">, keyof LinkProps>

/** Same props as before (`href`); implements navigation with React Router. */
export type AppLinkProps = Omit<LinkProps, "to"> &
  AnchorProps & {
    href: string
    /** Ignored (legacy Next prefetch); kept for call-site compatibility. */
    prefetch?: boolean
    children?: ReactNode
  }

export const AppLink = forwardRef<HTMLAnchorElement, AppLinkProps>(function AppLink(
  { href, prefetch: _prefetch, children, ...rest },
  ref
) {
  return (
    <Link ref={ref} to={href} {...rest}>
      {children}
    </Link>
  )
})
